import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CDMS_STUDY_STATUS_CODE: {
  STUDY_CLOSED: MvnCodeBE;
} = {
  STUDY_CLOSED: {
    code: "STUDY_CLOSED",
    status: 400,
    ko: "종료된 스터디에 접근할 수 없습니다.",
    en: "Can't access closed study.",
  },
};

MvnCodeInitiate(CDMS_STUDY_STATUS_CODE);
